module.exports = __webpack_public_path__ + "static/income_welfare.aac09377.png";